import { Class } from './class';

export class RememberedInformation {
  constructor(data) {
    /** @type {number | null} */
    this.rememberClassId = data.rememberClassId;

    /** @type {number | null} */
    this.rememberExamLanguageId = data.rememberExamLanguageId;

    /** @type {Class | null} */
    this.rememberClass = data.rememberClass;
  }
}
